import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20minimalist%20fashion%20lifestyle%20flatlay%20with%20designer%20sneakers%20hoodie%20watch%20and%20sunglasses%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20morning%20daylight%2C%20elegant%20product%20styling%2C%20cozy%20neutral%20aesthetic%2C%20editorial%20fashion%20photography%2C%20airy%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-v2-2026&orientation=landscape&nocache=true"
          alt="Sugargoo Spreadsheet fashion collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-xs font-medium text-background-50 whitespace-nowrap">Updated 2026 · Independent Resource</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
          The Ultimate <span className="text-accent-400">Sugargoo Spreadsheet</span> Resource
        </h1>

        <p className="text-base md:text-lg text-background-50/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover updated Sugargoo Spreadsheet lists, product finds, shopping guides, reviews, shipping costs, coupons and expert tips — all in one independent hub.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-accent-500 text-foreground-950 rounded-full text-base font-semibold hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 rounded-full text-base font-semibold hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-cart-2-line text-lg"></i>
          </a>
        </div>

        <div className="mt-10">
          <Link
            to="/article/sugargoo-spreadsheet-complete-guide"
            className="inline-flex items-center gap-2 text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            Read the Complete Sugargoo Spreadsheet Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {['Updated Spreadsheet Resources', 'Independent Shopping Guide', 'Real User Information', 'Beginner Friendly'].map((badge) => (
            <div key={badge} className="flex items-center gap-2">
              <div className="w-5 h-5 rounded-full bg-accent-500/30 flex items-center justify-center">
                <i className="ri-check-line text-background-50 text-xs"></i>
              </div>
              <span className="text-xs text-background-50/80 whitespace-nowrap">{badge}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#categories" className="text-background-50/50 hover:text-background-50 transition-colors cursor-pointer">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}